import React from 'react'
import './works.css'
import TaApp from '../../assets/TaApp.jpg'
import TicTacToe from '../../assets/TicTacToe.jpg'
import BookRecs from '../../assets/BookRec.jpg'
import MSOE from '../../assets/MSOE.jpg'

const Works = () => {
  const projects = [
    { 
      img: MSOE, 
      alt: "MSOE", 
      link: "https://github.com/mohsinshah04/MSOE_F1", 
      text: "MSOE Club Website",
      tech: ["React", "CSS", "JavaScript"]
    },
    { 
      img: TaApp, 
      alt: "TA Scheduling App", 
      link: "https://github.com/mohsinshah04/ta_project", 
      text: "TA Scheduling App",
      tech: ["Python", "Django", "SQL"]
    },
    { 
      img: TicTacToe, 
      alt: "TicTacToe", 
      link: "https://github.com/mohsinshah04/Tic-Tac-Toe", 
      text: "AI Tic-Tac-Toe",
      tech: ["Python", "AI", "Algorithms"]
    },
    { 
      img: BookRecs, 
      alt: "BookRecs", 
      link: "https://github.com/mohsinshah04/BookRecs", 
      text: "Book Recs Site",
      tech: ["React", "JavaScript", "HTML"]
    },
  ];

  return (
    <section id='works'>
      <h2 className="worksTitle">My Projects</h2>
      <span className="worksDesc">I take pride in staying organized in my work. As a CS student, I'm eager to develop my skills to address tasks in my life or the lives of others that could be automated, as well as creating great UI experiences.</span>
      <div className="worksImgs">
        {projects.map((project, index) => (
          <div key={index} className="worksItem" style={{ animationDelay: `${index * 0.1}s` }}>
            <img src={project.img} alt={project.alt} className="worksImg" />
            <div className="overlay">
              <div className="overlayContent">
                <h3 className="projectTitle">{project.text}</h3>
                <div className="techStack">
                  {project.tech.map((tech, techIndex) => (
                    <span key={techIndex} className="techTag">{tech}</span>
                  ))}
                </div>
                <a href={project.link} className="worksLink" target="_blank" rel="noopener noreferrer">
                  View Project →
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <a href="https://github.com/mohsinshah04" target="_blank" rel="noopener noreferrer">
        <button className="worksBtn">See More</button>
      </a>
    </section>
  );
}

export default Works;